import React from 'react';
import { Button, Div, Heading, P } from '@kizi/core-components';
import { Desktop, Mobile } from '../utils/breakpoint';
import {
  useCurrentStepIndex,
  useField,
  usePage,
  useWizardService,
} from '@kizi/comparator-core';
import { IconV2 } from '@kizi/shared-components';

export interface TopThreeSectionWrapperProps {
  label: string;
  compareAllThree?: boolean;
}

const CompareAllTopThreeProducts = () => {
  const wizard = useWizardService();
  const currentIndex = useCurrentStepIndex();
  const { state } = usePage() as any;
  const comparisonProductsFiled = useField('overview.comparisonProducts');

  const topThreeProducts = state?.topThree as any[];

  const redirectToCompare = () => {
    if (currentIndex !== undefined)
      wizard?.send({ type: 'GOTO', index: currentIndex + 1 });
  };

  return (
    <Div
      display={'flex'}
      justifyContent={'space-between'}
      alignItems={'center'}
      backgroundColor={'#FFF'}
      padding={'8px 8px 8px 24px'}
      maxWidth={'660px'}
      borderRadius={'8px'}
      css={{
        margin: '32px auto 0 auto',
        boxShadow:
          '0px 4px 8px 0px rgba(62, 72, 101, 0.08), 0px 2px 8px 0px rgba(78, 90, 126, 0.08)',
      }}
    >
      <P variant="footnoteRegular">Alle details van de top 3 vergelijken?</P>
      <Button
        variant="transparent"
        padding={'4px 8px 4px 16px'}
        display="flex"
        alignItems="center"
        flexDirection={'row'}
        css={{
          gap: '8px',
          boxShadow:
            '0px 4px 12px 0px rgba(62, 72, 101, 0.14), 0px 0px 2px 0px rgba(78, 90, 126, 0.08)',
          borderRadius: '8px',
        }}
        onClick={() => {
          comparisonProductsFiled?.set({
            value: JSON.stringify(topThreeProducts),
          });

          redirectToCompare();
        }}
      >
        <P variant="footnoteImportant">Vergelijken</P>
        <IconV2 fill="#2B2F3B" size={20} name={'arrow-right'} />
      </Button>
    </Div>
  );
};

export const TopThreeSectionWrapper: React.FC<TopThreeSectionWrapperProps> = ({
  label,
  children,
  compareAllThree = false,
  ...rest
}) => {
  const { state } = usePage();
  const topThreeProducts = state?.topThree as any;
  const products = state?.productList as any;

  if (
    !state ||
    topThreeProducts === undefined ||
    products?.length <= 4 ||
    topThreeProducts?.length <= 2
  ) {
    return null;
  }

  return (
    <Div {...rest} variant="topThreeOuterWrapper">
      <Desktop minWidth="1107px">
        <Div>
          <Heading
            as="h3"
            variant="H3"
            textAlign="center"
            pt="40px"
            mt="0"
            mb="0"
            pb="32px"
            fontSize="32px !important"
          >
            {label}
          </Heading>
          <Div
            mx={[null, null, null, 'auto']}
            px={[4, 4, 4, 0]}
            width={[null, null, null, 1180]}
          >
            {children}
          </Div>
        </Div>
      </Desktop>
      <Mobile maxWidth="1106px">
        <Heading
          as="h3"
          variant="H3"
          textAlign="center"
          margin="32px 0 40px 0"
          fontSize="32px !important"
        >
          {label}
        </Heading>
        <Div position="relative" variant="sliderWrapper">
          {children}
        </Div>
      </Mobile>
      {compareAllThree && (
        <Div display={['none', 'none', 'block']}>
          <CompareAllTopThreeProducts />
        </Div>
      )}
    </Div>
  );
};
